export default __webpack_public_path__ + "static/media/cheatday_3@2x.be1a3808.jpg";